import React from "react";
import {
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  Typography,
  Badge,
  Divider,
  ListItemIcon, Checkbox
} from "@mui/material";
import {formatDistanceToNow} from "date-fns";
import {hu} from "date-fns/locale";
import {UserAvatar} from "../../General/User/UserAvatar";

interface NotificationItemProps {
  notification: any;
  handleClickNotification: (notification: any) => void;
  checked: any;
  onCheck: (value: any) => void;
}

const NotificationItem: React.FC<NotificationItemProps> = ({notification, handleClickNotification,checked,onCheck}) => {
  const date = new Date(notification?.created_at);
  date.setMinutes(date.getMinutes() - 1);


  return (
    <>
      <ListItemButton
        alignItems="flex-start"
        sx={{
          background: !notification?.seen ? "" : "#eeeeee",
        }}

      >
        <ListItemIcon
        sx={{
          minWidth: '20px'
        }}
        >
          <Checkbox
            edge="start"
            checked={checked}
            tabIndex={-1}
            disableRipple
            inputProps={{ 'aria-labelledby': notification?.id }}
            onChange={(event, checked)=>{
              onCheck(checked);
            }}
          />
        </ListItemIcon>
        <ListItemAvatar
          onClick={() => handleClickNotification(notification)}
        >
          <UserAvatar user={notification?.user}/>
        </ListItemAvatar>

        <ListItemText
          onClick={() => handleClickNotification(notification)}
          primary={
            <React.Fragment>
              {notification?.group_count === 1 && (
                <Typography
                  sx={{display: "inline", fontWeight: "bolder", marginRight: "5px"}}
                  component="b"
                >
                  {notification?.user?.name
                    ? notification?.user?.name[0].toUpperCase() + notification?.user?.name.slice(1)
                    : "Unknown"}
                </Typography>
              )}
              {notification?.text}
            </React.Fragment>
          }
          secondary={
            <Typography sx={{display: "block", marginTop: "2px"}} component="span" variant="body2">
              {`${formatDistanceToNow(date, {addSuffix: true, locale: hu})}`}
            </Typography>
          }
        />
        {!notification?.seen && (
          <Badge
            sx={{
              marginTop: "16px",
              marginRight: "4px"
            }}
            color="primary"
            variant={notification?.group_count === 1 ? "dot" : "standard"}
            badgeContent={notification?.group_count}
          >
            <div></div>
          </Badge>
        )}
      </ListItemButton>
      <Divider variant="fullWidth" component="li"/>
    </>
  );
};

export default NotificationItem;